import type { AccountSwitcherProps } from "./components/AccountSwitcher";
import type * as lazyIndex from "./lazyIndex";
import { type LazyComponent, LazyModule, createLazyComponent } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "AccountSwitcher" */ "./lazyIndex"), { name: "AccountSwitcher" });

export const AccountSwitcher: LazyComponent<AccountSwitcherProps, unknown, void> = createLazyComponent(lazyModule, m => m.AccountSwitcher);
